import primaryComponents from "..";
import "./BoxedRadioInput.scss";

const BoxedRadioInput = ({
  children,
  name,
  value,
  id,
  isChecked,
  isControlled = false,
  setRadioValue,
  isDisabled = false,
  classNames = "",
  contentStyle = {},
  ...rest
}) => {
  const handleChange = () => {
    if (!isDisabled && setRadioValue) {
      setRadioValue(value);
    }
  };

  return (
    <label
      className={`boxed-radio ${isChecked ? "active" : ""} ${
        isDisabled ? "disabled" : ""
      } ${classNames}`}
      onClick={handleChange}
      htmlFor={id}
      {...rest}
    >
      <primaryComponents.RadioButton
        name={name}
        value={value}
        id={id}
        checked={isChecked}
        isControlled={isControlled}
        isDisabled={isDisabled}
        onChange={handleChange}
      />
      <span style={{ ...contentStyle }}>{children}</span>
    </label>
  );
};

export default BoxedRadioInput;
